import { Component } from '@angular/core';

@Component({
  selector: 'fgb-how-it-works-modal',
  templateUrl: './how-it-works-modal.component.html',
  styleUrl: './how-it-works-modal.component.scss',
})
export class HowItWorksModalComponent {}
